import { getOrderFulfillmentCTA } from "./shared";
export var AddOrUpdate = function AddOrUpdate(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return addOrUpdateBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return addOrUpdateBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var addOrUpdateBuilder = function addOrUpdateBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "qfCs6w",
        defaultMessage: [{
          "type": 0,
          "value": "Ajouter les informations de suivi lorsque vous expédiez une commande par vos propres moyens"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "UbgtZ8",
        defaultMessage: [{
          "type": 0,
          "value": "Vous pouvez ajouter ou modifier les informations de suivi sur la page de traitement des commandes, à l'« Étape 4. Informations d'expédition ». Vous trouverez ci-dessous les articles du Centre d'aide qui vous fourniront des instructions plus détaillées."
        }]
      })];
    }
  };
};